import GraficoPrevisao from "./GraficoPrevisao";
import { formatMeters } from "./formatters";
import TabelaPrevisao from "../../Tabelas/TabelaPrevisao";

const StatCard = ({ label, value, detail }) => (
  <div className="p-p-3 p-shadow-1" style={{ borderRadius: 6, minWidth: 180 }}>
    <span className="p-d-block p-text-secondary">{label}</span>
    <strong className="p-d-block p-mt-2" style={{ fontSize: "1.25rem" }}>{value}</strong>
    {detail ? <small className="p-d-block p-mt-1">{detail}</small> : null}
  </div>
);

const VisaoGeral = ({ overview, series, futureLabels }) => {
  if (!overview) return null;

  return (
    <>
      <div className="p-d-flex p-flex-wrap p-mb-4" style={{ gap: 12 }}>
        <StatCard label="Média histórica" value={formatMeters(overview.average)} detail={`${overview.months} meses`} />
        <StatCard label="Pico máximo" value={formatMeters(overview.peak.value)} detail={overview.peak.label} />
        <StatCard label="Vale mínimo" value={formatMeters(overview.valley.value)} detail={overview.valley.label} />
        <StatCard label="Média dos últimos 3 meses" value={formatMeters(overview.lastThreeAverage)} />
      </div>
      <GraficoPrevisao series={series} futureLabels={futureLabels} />
      <TabelaPrevisao series={series} futureLabels={futureLabels} />
    </>
  );
};

export default VisaoGeral;
